export default __webpack_public_path__ + "static/media/carAC.4a401d44.svg";